import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import _ from "lodash";
import {
  Grid,
  Typography,
  withStyles,
  withWidth,
  isWidthUp,
  Hidden,
  Link,
} from "@material-ui/core";
import WaveBorder from "shared/components/WaveBorder";
import { Navigation } from "utils/constant";

const styles = (theme) => ({
  top: {
    zIndex: 1000,
    backgroundColor: "transparent",
  },
  footerInner: {
    color: "#ABBFD6",
    fontWeight: `${theme.typography.fontWeightRegular} !important`,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
  },
  link: {
    color: "#ABBFD6",
  },
});

const lightBlue = [Navigation.home.value];

const Footer = (props) => {
  const { classes, theme, width, selectedTab, className } = props;
  const { background } = theme.palette;
  const isLightBlue = useMemo(() => {
    return !_.includes(lightBlue, selectedTab);
  }, [selectedTab]);

  const upperColor = useMemo(() => {
    if (selectedTab === "contact") {
      return background.transparent;
    }
    return isLightBlue ? background.default : background.paper;
  }, [background, isLightBlue, selectedTab]);
  const wave = useMemo(() => {
    if (!selectedTab) {
      return null;
    }
    return (
      <WaveBorder
        upperColor={upperColor}
        lowerColor={isLightBlue ? background.paper : background.default}
        animationNegativeDelay={4}
      />
    );
  }, [background, isLightBlue, selectedTab, upperColor]);

  return (
    <footer className={classes.top}>
      {wave}
      <div
        className={clsx(
          classes.footerInner,
          {
            "default-page": !isLightBlue,
            "white-page": isLightBlue,
          },
          className
        )}
      >
        <Grid container spacing={isWidthUp("md", width) ? 4 : 2}>
          <Hidden smDown>
            <Grid item xs={12} sm={4} md={4}>
              <Typography align="center" variant="body2">
                咨询电话：(020)34473741
              </Typography>
            </Grid>
          </Hidden>
          <Hidden smDown>
            <Grid item xs={12} sm={4} md={4}>
              <Typography align="center" variant="body2">
                广州市荣晶软件科技有限公司©2022版权所有
              </Typography>
            </Grid>
          </Hidden>
          <Hidden smDown>
            <Grid item xs={12} sm={4} md={4}>
              <Typography align="center" variant="body2" className="pointer">
                <Link
                  href="https://beian.miit.gov.cn/"
                  rel="noopener"
                  target="_blank"
                  className={classes.link}
                >
                  ICP证：粤ICP备2021171282号-1
                </Link>
              </Typography>
            </Grid>
          </Hidden>
          <Hidden mdUp>
            <Grid item xs={12} sm={12} md={4}>
              <Typography align="center" variant="body2">
                Copyright © 2022 荣晶科技.All Rights Reserved.
              </Typography>
              <Typography align="center" variant="body2">
                粤ICP备2021171282号-1
              </Typography>
            </Grid>
          </Hidden>
        </Grid>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  selectedTab: PropTypes.string,
  className: PropTypes.string,
};

export default withWidth()(
  withStyles(styles, { withTheme: true })(memo(Footer))
);
